import React, { useState } from 'react';
import { Layout, Menu, Button, Typography, Input, Modal } from 'antd';
import {
  HomeOutlined,
  PlusOutlined,
  BarChartOutlined,
  LogoutOutlined,
  UserOutlined,
  LinkOutlined,
  RobotOutlined,
  SettingOutlined
} from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom'; // 已移除，使用logout函数
import MemoList from '../components/MemoList';
import MemoForm from '../components/MemoForm';
import Dashboard from '../components/Dashboard';
import UserManagement from '../components/UserManagement';
import UrlChecker from '../components/UrlChecker';
import ChatGPT from '../components/ChatGPT';
import LoginLogs from '../components/LoginLogs';
import SystemSettings from '../components/SystemSettings';
import { logout, hasPermission } from '../utils/auth';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;
const { Search } = Input;

export default function MainPage() {
  const [selectedKey, setSelectedKey] = useState('memos');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingMemo, setEditingMemo] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [refresh, setRefresh] = useState(false);
  
  // const navigate = useNavigate(); // 已移除，使用logout函数

  const handleMenuClick = (e) => {
    setSelectedKey(e.key);
  };

  const handleAdd = () => {
    setEditingMemo(null);
    setIsModalVisible(true);
  };

  const handleEdit = (memo) => {
    setEditingMemo(memo);
    setIsModalVisible(true);
  };

  const handleFinish = () => {
    setEditingMemo(null);
    setIsModalVisible(false);
    setRefresh(!refresh);
  };

  const handleCancel = () => {
    setEditingMemo(null);
    setIsModalVisible(false);
  };

  const handleLogout = async () => {
    try {
      // 调用后端退出API（可选，用于记录退出时间）
      // await authAPI.logout();
    } catch (error) {
      console.error('退出登录API调用失败:', error);
    } finally {
      // 使用统一的退出函数清空所有认证信息
      logout();
    }
  };

  const renderContent = () => {
    switch (selectedKey) {
      case 'memos':
        return (
          <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Title level={3}>备忘录列表</Title>
              <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                <Search
                  placeholder="搜索网址、备注、IP、用户名等（支持多关键词）"
                  allowClear
                  onSearch={setSearchTerm}
                  style={{ width: 350 }}
                  onChange={e => setSearchTerm(e.target.value)}
                  enterButton="搜索"
                  loading={false}
                />
                {hasPermission('memo_write') && (
                  <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                    ADD 
                  </Button>
                )}
              </div>
            </div>
            <MemoList 
              onEdit={handleEdit} 
              refresh={refresh} 
              searchTerm={searchTerm} 
            />
          </div>
        );
      case 'dashboard':
        return <Dashboard />;
      case 'ai-chat':
        return <ChatGPT />;
      case 'url-checker':
        return hasPermission('url_check') ? <UrlChecker /> : <div>仅管理员可使用URL检测</div>;
      case 'users':
        return <UserManagement />;
      case 'login-logs':
        return <LoginLogs isAdmin={hasPermission('login_logs')} />;
      case 'system-settings':
        return <SystemSettings isSuperAdmin={hasPermission('system_settings')} />;
      default:
        return (
          <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Title level={3}>LIST</Title>
              <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                <Search
                  placeholder="Search by URL or remark"
                  allowClear
                  onSearch={setSearchTerm}
                  style={{ width: 280 }}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                {hasPermission('memo_write') && (
                  <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                    添加备忘录
                  </Button>
                )}
              </div>
            </div>
            <MemoList 
              onEdit={handleEdit} 
              refresh={refresh} 
              searchTerm={searchTerm} 
            />
          </div>
        );
    }
  };

  const menuItems = [
    // 所有用户都可以访问
    {
      key: 'dashboard',
      icon: <BarChartOutlined />,
      label: 'Dashboard',
    },
    {
      key: 'memos',
      icon: <HomeOutlined />,
      label: 'MemoList',
    },   
    {
      key: 'ai-chat',
      icon: <RobotOutlined />,
      label: 'ChatGPT',
    },
    // 管理员和超级管理员可以访问
    ...(hasPermission('url_check') ? [{
      key: 'url-checker',
      icon: <LinkOutlined />,
      label: 'URL检测',
    }] : []),
    ...(hasPermission('user_management') ? [{
      key: 'users',
      icon: <UserOutlined />,
      label: '用户管理',
    }] : []),
    // 登录记录：超级管理员看所有记录，其他用户看自己的记录
    {
      key: 'login-logs',
      icon: <UserOutlined />,
      label: hasPermission('login_logs') ? '登录记录' : '我的登录',
    },
    // 只有超级管理员可以访问
    ...(hasPermission('system_settings') ? [{
      key: 'system-settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    }] : []),
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible breakpoint="lg" collapsedWidth="80">
        <div className="logo" />
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['memos']}
          selectedKeys={[selectedKey]}
          onClick={handleMenuClick}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 24 }}>
          <div style={{ paddingLeft: 24 }}>
            <Title level={3} style={{ margin: 0 }}>项目管理备忘录</Title>
          </div>
          <Button type="primary" icon={<LogoutOutlined />} onClick={handleLogout}>
            退出登录
          </Button>
        </Header>
        <Content style={{ margin: '24px 0 0' }}>
          <div style={{ padding: 24, background: '#fff', minHeight: 360, maxWidth: 1400, width: '100%', margin: '0 auto' }}>
            {renderContent()}
          </div>
        </Content>
        <Modal
          title={editingMemo ? '编辑备忘录' : '添加备忘录'}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          <MemoForm memo={editingMemo} onFinish={handleFinish} />
        </Modal>
      </Layout>
    </Layout>
  );
} 